<template>
  <div class="flex-1 overflow-auto">
    <campaigns-table
      :campaigns="campaigns"
      :show-empty-result="showEmptyResult"
      :is-loading="uiFlags.isFetching"
      :campaign-type="type"
      @edit="openEditPopup"
      @cancel="openCancelPopup"
      @on-sort-change="onSortChange"
    />
    <table-footer
      :current-page="Number(campaignMeta.currentPage)"
      :total-count="campaignMeta.count"
      :page-size="15"
      @page-change="onPageChange"
    />    
    <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-campaign
        :selected-campaign="selectedCampaign"
        @on-close="hideEditPopup"
      />
    </woot-modal>
    <woot-delete-modal
      :show.sync="showCancelConfirmationPopup"
      :on-close="closeCancelPopup"
      :on-confirm="confirmCancel"
      :title="$t('CAMPAIGN.CANCEL.CONFIRM.TITLE')"
      :message="$t('CAMPAIGN.CANCEL.CONFIRM.MESSAGE')"
      :confirm-text="$t('CAMPAIGN.CANCEL.CONFIRM.YES')"
      :reject-text="$t('CAMPAIGN.CANCEL.CONFIRM.NO')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import campaignMixin from 'shared/mixins/campaignMixin';
import CampaignsTable from './CampaignsTable';
import EditCampaign from './EditCampaign';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import { CAMPAIGNS_EVENTS } from '../../../../helper/AnalyticsHelper/events';

export default {
  components: {
    CampaignsTable,
    EditCampaign,
    TableFooter,
  },
  mixins: [alertMixin, campaignMixin],
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showEditPopup: false,
      selectedCampaign: {},
      showCancelConfirmationPopup: false,
      sortConfig: { created_at: 'desc' }
    };
  },
  computed: {
    ...mapGetters({
      campaigns: 'campaigns/getCampaigns',
      uiFlags: 'campaigns/getUIFlags',
      labelList: 'labels/getLabels',
      campaignMeta: 'campaigns/getMeta',
    }),
    showEmptyResult() {
      const hasEmptyResults =
        !this.uiFlags.isFetching && this.campaigns.length === 0;
      return hasEmptyResults;
    },
  },
  methods: {
    onPageChange(page) {
      const requestParams = {page: page, campaignType: this.campaignType}
      this.$store.dispatch('campaigns/get', requestParams)
    },
    getSortAttribute() {
      let sortAttr = Object.keys(this.sortConfig).reduce((acc, sortKey) => {
        const sortOrder = this.sortConfig[sortKey];
        if (sortOrder) {
          const sortOrderSign = sortOrder === 'asc' ? '' : '-';
          return `${sortOrderSign}${sortKey}`;
        }
        return acc;
      }, '');
      if (!sortAttr) {
        this.sortConfig = { created_at: 'desc' };
        sortAttr = '-created_at';
      }
      return sortAttr;
    },    
    onSortChange(params) {
      this.sortConfig = params
      console.log("params_created_at", params.created_at)
      const requestParams = {page: this.campaignMeta.currentPage, campaignType: this.campaignType, sortAttr: this.getSortAttribute()}
      this.$store.dispatch('campaigns/get', requestParams)

    },    
    openEditPopup(campaign) {
      this.selectedCampaign = campaign;
      this.showEditPopup = true;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    openCancelPopup(campaign) {
      this.showCancelConfirmationPopup = true;
      this.selectedCampaign = campaign;
    },
    closeCancelPopup() {
      this.showCancelConfirmationPopup = false;
    },
    confirmCancel() {
      this.closeCancelPopup();
      const { id } = this.selectedCampaign;
      this.cancelCampaign(id);
    },
    async cancelCampaign(id) {
      try {
        await this.$store.dispatch('campaigns/update', {
          id: this.selectedCampaign.id,
          campaign_status: 'cancelled',
        });
        this.showAlert(this.$t('CAMPAIGN.DELETE.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(this.$t('CAMPAIGN.DELETE.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button-wrapper {
  @apply flex justify-end pb-2.5;
}
</style>
